import * as api from '../download-report-page.api';
import actionTypes from './action-types';

export const downloadReportsPackRequest = () => ({
  type: actionTypes.DOWNLOAD_REPORTS_PACK_REQUEST,
  isLoading: true,
  error: false,
});

export const downloadReportsPackSuccess = () => ({
  type: actionTypes.DOWNLOAD_REPORTS_PACK_SUCCESS,
  isLoading: false,
  error: false,
});

export const downloadReportsPackFailure = () => ({
  type: actionTypes.DOWNLOAD_REPORTS_PACK_FAILURE,
  isLoading: false,
  error: true,
});

export const downloadReportsPack = (token) => async (dispatch) => {
  try {
    dispatch(downloadReportsPackRequest());
    const reports = await api.downloadReportsPack(token);

    const result = await reports.promise;

    window.saveAs(result.data, 'Reports.zip');
    dispatch(downloadReportsPackSuccess());
  } catch (error) {
    console.error('DOWNLOAD_REPORTS_PACK', error);
    dispatch(downloadReportsPackFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/download-report-page/actions/download-report-page.acions.js